/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, FlexboxGrid, Table } from 'rsuite';

import { useDispatch, useSelector } from 'react-redux';
import { Container } from '~/styles/tabela1';

import {
  buscarNotificacoes,
  marcarNotificacoesLidas as atualizarNotificacoesLidas,
} from '~/store/modulos/notificacao/actions';
import SearchInputTable from '~/components/SearchInputTable';
import { InputDataRange } from '~/components/InputDataRange';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { CelulaNotifcacao } from '~/components/CelulaNotificacao';
import { MdOutlinePeopleOutline } from 'react-icons/md';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { TbCertificate } from 'react-icons/tb';
import { FaRegStar } from 'react-icons/fa';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';

const { HeaderCell, Column } = Table;

function NovoProfissional() {
  const [pagina, setPagina] = useState(1);
  const [data, setData] = useState([]);
  const [textodigitado, setTextoDigitado] = useState('');
  const [orderBy, setOrderBy] = useState('order by data desc');

  const notificacoes = useSelector((state) => state.notificacao.notificacoes);
  const carregando = useSelector((state) => state.notificacao.carregando);
  const novosProfissionaisCriadosNaoLidos = useSelector((state) => state.notificacao.novosProfissionaisCriadosNaoLidos);

  const dispatch = useDispatch();

  useEffect(() => {
    if (notificacoes.quantidade > 0 && notificacoes.lista.length === 0) setPagina(1)
    if (data) {
      dispatch(
        buscarNotificacoes({
          pagina,
          titulo: "Profissional novo criado",
          mensagem: textodigitado,
          dataInicio: data[0],
          dataFim: data[1],
          orderBy
        })
      );
    }
    if (!data) {
      dispatch(
        buscarNotificacoes({
          pagina,
          titulo: "Profissional novo criado",
          mensagem: textodigitado,
          orderBy
        })
      );
    }
  }, [pagina, dispatch, textodigitado, data, novosProfissionaisCriadosNaoLidos, notificacoes.quantidade, orderBy]);

  async function marcarNotificacoesLidas() {
    dispatch(atualizarNotificacoesLidas({ pagina, titulo: "Profissional novo criado" }));
  }

  return (
    <Container>
      <PageHeader
        title="Novos Profissionais"
        subtitle="Aqui você poderá ver as notificações de novos profissionais criados."
      />
      <MetricsCards
        items={[
          {
            title: 'Total Profissionais',
            value: notificacoes.quantidade,
            icon: <MdOutlinePeopleOutline size="30px" />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Perfil Bom',
            value: '-',
            icon: <IoMdCheckmarkCircleOutline size="30px" />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Certificados',
            value: '-',
            icon: <TbCertificate size="30px" />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Interessados',
            value: '-',
            icon: <FaRegStar size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />
      <AdvancedFilters
        // activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable
              place='Buscar mensagem...'
              setTextoDigitado={setTextoDigitado}
              estilo={{ width: '700px' }} />
            <InputDataRange
              // format="DD/MM/YYYY"
              ranges={[]}
              // placeholder="Data"
              value={data}
              onChange={setData}

            />
            <Button
              style={{ marginLeft: '15px' }}
              // eslint-disable-next-line react/jsx-no-bind
              onClick={marcarNotificacoesLidas}
              size="sm"
            >
              Marcar Todas como lidas
            </Button>
          </>
        }
      />

      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={notificacoes.lista}
          quantidade={notificacoes.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
        >
          <Column resizable width={400} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Mensagem' tooltip='Mensagem' />
            </HeaderCell>
            <CelulaNotifcacao dataKey="mensagem" />
          </Column>
          <Column resizable width={170} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Data' tooltip='Data' />
            </HeaderCell>
            <CelulaNotifcacao dataKey="data" />
          </Column>
        </TablePagination>
      </FlexboxGrid>
    </Container>
  );
}

export default NovoProfissional;
